import { useBox } from "@react-three/cannon";
import { useRef } from "react";
import { Mesh } from "three";
import { ObjectProps, useDragConstraint } from "../utils";

export default ({position, rotation}: ObjectProps) => {
  const [ref] = useBox(() => ({
    mass: 0.005,
    position: position ?? [0, 0, 0],
    rotation: rotation ?? [0, 0, 0],
    args: [2.5, 0.0001, 2],
    material: {
      friction: 0.8,
      restitution: 0.3,
    },
    type: 'Dynamic'
  }), useRef<Mesh>(null));
  const bind = {}; // useDragConstraint(ref);
  return (
    <mesh ref={ref} castShadow receiveShadow {...bind}>
      <boxGeometry args={[2.5, 0.05, 2]} />
      <meshStandardMaterial 
        roughness={0.8}
        metalness={0.1}
        color="#2a2a2a"
      />
    </mesh>
  );
};
